import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=aac78df2"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"
import style0 from "./AdminSidebar.vue?vue&type=style&index=0&id=aac78df2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aac78df2')) {
      api.createRecord('aac78df2', component.options)
    } else {
      api.reload('aac78df2', component.options)
    }
    module.hot.accept("./AdminSidebar.vue?vue&type=template&id=aac78df2", function () {
      api.rerender('aac78df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminSidebar.vue"
export default component.exports